import React from 'react';


function Heading({title}){
  return (
    <div className="heading">
        <h2>{title}</h2>
        </div>
  );
};
  
export default Heading;